import { queryOptions } from "@tanstack/react-query";
import { getOrganizationProgram, listOrganizationPrograms } from "api-client";

import {
  type ProgramDetail,
  type ProgramList,
  type ProgramListInput,
  type ProgramsRepository,
} from "./ProgramsRepository";

export function createOrganizationProgramsRepository(organizationId: string) {
  const rootKey = ["programs", "organization", organizationId] as const;
  const repository = {
    listOptions(input: ProgramListInput) {
      return queryOptions<ProgramList>({
        queryKey: [...rootKey, "list", input],
        async queryFn() {
          const response = await listOrganizationPrograms({
            path: { organizationId },
            query: input,
          });
          return response.data.data;
        },
      });
    },
    detailOptions(programId: string) {
      return queryOptions<ProgramDetail>({
        queryKey: [...rootKey, "detail", programId],
        async queryFn() {
          const response = await getOrganizationProgram({
            path: { organizationId, programId },
          });
          return response.data.data;
        },
      });
    },
  };

  return repository satisfies ProgramsRepository;
}
